import { ACTIVATION_TYPES } from "utils/constants";

const ActivationBadgeType = ({ text, className }) => {
    return (
        <div
            className={`flex h-[23px] w-fit skew-x-[-9deg] items-center justify-center rounded-tl-[0.6rem] rounded-br-[0.6rem] py-0.5 px-[13px] text-[10px] font-[1000] uppercase italic text-white ${
                text?.toLowerCase() === ACTIVATION_TYPES.ONSITE
                    ? "bg-brand-500"
                    : text?.toLowerCase() === ACTIVATION_TYPES.CLOUD
                    ? "bg-[#25a3dd]"
                    : ""
            } ${className ?? ""}`}
        >
            <span className="inline-block skew-x-[9deg]">{text}</span>
        </div>
    );
};

export default ActivationBadgeType;
